import React from "react";

export default function ChangeAvatarImage() {
  return (
    <svg
      width="47"
      height="47"
      viewBox="0 0 47 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="23.8544"
        cy="23.8544"
        r="22.1455"
        fill="#F3F3F5"
        stroke="white"
        strokeWidth="2"
      />
      <g clipPath="url(#clip0)">
        <path
          d="M34.8184 19.0578V31.3919C34.8184 32.5268 33.8976 33.4476 32.7627 33.4476H14.9468C13.8119 33.4476 12.8911 32.5268 12.8911 31.3919V19.0578C12.8911 17.9229 13.8119 17.0021 14.9468 17.0021H18.7155L19.2423 15.5931C19.5421 14.7923 20.3087 14.2612 21.1652 14.2612H26.54C27.3965 14.2612 28.1631 14.7923 28.4629 15.5931L28.994 17.0021H32.7627C33.8976 17.0021 34.8184 17.9229 34.8184 19.0578ZM28.994 25.2249C28.994 22.3897 26.6899 20.0857 23.8547 20.0857C21.0196 20.0857 18.7155 22.3897 18.7155 25.2249C18.7155 28.06 21.0196 30.3641 23.8547 30.3641C26.6899 30.3641 28.994 28.06 28.994 25.2249ZM27.6235 25.2249C27.6235 27.302 25.9318 28.9936 23.8547 28.9936C21.7777 28.9936 20.086 27.302 20.086 25.2249C20.086 23.1478 21.7777 21.4561 23.8547 21.4561C25.9318 21.4561 27.6235 23.1478 27.6235 25.2249Z"
          fill="#5B5E71"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="21.9273"
            height="21.9273"
            fill="white"
            transform="translate(12.8911 12.8909)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
